if (!customElements.get('hello-bar')) {
  customElements.define(
    'hello-bar',
    class HelloBar extends HTMLElement {
      constructor() {
        super();
        this.dateUtils = new DateUtils()
      }

      connectedCallback() {
        this.handleScheduledMessages()
        this.handleCountdowns()
      }

      handleScheduledMessages() {
        const messages = this.querySelectorAll('[data-message]');
        if (!messages?.length) return
        Array.from(messages).forEach(el => {
          this.handleSchedule.bind(this, el)()
        })
      }

      handleSchedule(message) {
          const currentDate = this.dateUtils.getCurrentUTCDate();

          const startDate =  message.dataset.startDate && this.dateUtils.formatDate(message.dataset.startDate);
          const endDate =  message.dataset.endDate && this.dateUtils.formatDate(message.dataset.endDate);

          console.log("startDate", startDate)
        console.log("endDate", endDate)
        if (
          (!startDate || currentDate >= startDate) &&
          (!endDate || currentDate <= endDate)
        ) {
          message.classList.remove('twcss-sr-only');
        }


      }

      handleCountdowns() {
        const countdowns = this.querySelectorAll('[data-message] [data-countdown]')
        if (!countdowns) return

        Array.from(this.querySelectorAll('[data-countdown]')).forEach(el => {
          this.handleCountdown.bind(this, el)()
        })
        setInterval(async () => {
          Array.from(this.querySelectorAll('[data-countdown]')).forEach(el => {
            this.handleCountdown.bind(this, el)()
          })
        }, 1000);
      }

      getCountdownDifference = (date) => {
        const currentDate = this.dateUtils.getCurrentUTCDate();
        const countDownDate = this.dateUtils.formatDate(date);
        return countDownDate - currentDate;
      }


      handleCountdown(element) {
        const differenceMs = this.getCountdownDifference(element.dataset.countdown);
        if (Math.sign(differenceMs) === -1) return
        const timeObj = this.dateUtils.getTimeObjFromMS(this.getCountdownDifference(element.dataset.countdown));
        const times = this.dateUtils.getTimeString(timeObj);
        element.innerText = ` ${times}`;
      }
    }
  );
}
